import { LoginPage } from "@/features/auth/pages/LoginPage";
import {
	PASSWORD_MODE,
	type PasswordChangeMode,
} from "@/features/auth/usecases/passwordMode";
import { createFileRoute } from "@tanstack/react-router";

const VENDOR_PATH_PREFIX = "/vendor";

type LoginSearch = { redirect?: string; pw?: PasswordChangeMode };

export const Route = createFileRoute("/vendor/login")({
	validateSearch: (search: Record<string, unknown>): LoginSearch => ({
		redirect:
			typeof search.redirect === "string" &&
			search.redirect.startsWith(VENDOR_PATH_PREFIX)
				? search.redirect
				: undefined,
		pw: search.pw === PASSWORD_MODE.Change ? PASSWORD_MODE.Change : undefined,
	}),
	component: VendorLoginRoute,
});

function VendorLoginRoute() {
	const { redirect, pw } = Route.useSearch();
	return <LoginPage redirectPath={redirect} passwordMode={pw} />;
}
